import { render, staticRenderFns } from "./super-admin.vue?vue&type=template&id=50733660&scoped=true"
import script from "./super-admin.vue?vue&type=script&lang=js"
export * from "./super-admin.vue?vue&type=script&lang=js"
import style0 from "./super-admin.vue?vue&type=style&index=0&id=50733660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50733660",
  null
  
)

export default component.exports